import { useFormikContext } from "formik";
import React, { useState } from "react";

import openedLock from "../../../assets/locker.svg";
import closedLock from "../../../assets/closedLock.svg";
import { ApplicationStatus } from "../../../common/enums/clubs-wizard.enum";
import { ICreateClubWizardForm } from "../../../common/interfaces/clubs-wizard.interface";
import "./ApplicationStatusBar.scss";
import ToggleButon from "../../ToggleButton/ToggleButton";

const ApplicationStatusBar = ({ clubApplicationStatus }) => {
  const { setFieldValue, values } = useFormikContext<ICreateClubWizardForm>();
  const [activeStatus, setStatus] = useState<string>(
    values.clubApplicationStatus
  );

  const setApplicationStatus = (status: ApplicationStatus) => {
    setStatus(status);
    setFieldValue(clubApplicationStatus.name, status);
  };

  const applicationConfig = [
    {
      onClick: () => setApplicationStatus(ApplicationStatus.Opened),
      isActive: activeStatus === ApplicationStatus.Opened,
      description: "  Anyone can apply to join the club",
      icon: openedLock,
      title: "Open",
    },
    {
      onClick: () => setApplicationStatus(ApplicationStatus.Closed),
      isActive: activeStatus === ApplicationStatus.Closed,
      description: "Founder needs to invite new member",
      icon: closedLock,
      title: "Closed",
    },
  ];

  return (
    <div className="application-status">
      <ToggleButon title="Club application status" items={applicationConfig} />
    </div>
  );
};

export default ApplicationStatusBar;
